<template style="">
  <div style="width: 100%; background-color: #e6f0f2">
    <div style="width: 50%; margin: 0 auto; min-width: 730px">
      <div style="padding-top: 30px">
        <a href="https://www.ceprei.com/index.html">
          <img
            src="https://www.ceprei.com/assets/img/logo1-default.png"
            alt="Logo"
        /></a>
      </div>
    </div>

    <div
      style="
        width: 100%;
        height: 60px;
        background-color: #dcdcdc;
        padding-top: 3px;
        padding-bottom: 1px;
      "
    >
      <div style="width: 100%; height: 60px; background-color: #e6f0f2">
        <div style="width: 50%; margin: 0 auto; min-width: 730px">
          <div
            style="
              float: left;
              font-size: 250%;
              font-weight: bold;
              margin-top: 10px;
            "
          >
           所办企业信息查询
          </div>
          <div style="float: right; margin-top: 15px; color: #97a8be">
            <a href="https://www.ceprei.com/">首页</a> / 所办企业信息查询
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        width: 50%;
        margin: 0 auto;
        margin-top: 30px;
        min-width: 730px;
        background-color: #e6f0f2;
      "
    >
      <el-input
        placeholder="请输入企业名称"
        v-model="unitName"
        style="width: 60%"
        size="large"
      >
        <template slot="prepend">企业名称:</template>
        <el-button
          slot="append"
          icon="el-icon-search"
          style="color: #08c; font-weight: bold"
          @click="loadData()"
          >查询/Search</el-button
        >
      </el-input>
    </div>

    <div
      v-if="!seachShow"
      style="
        width: 85%;
        margin: 0 auto;
        border: 1px dashed #000;
        margin-top: 40px;
        min-width: 730px;
        background-color: #e6f0f2;
      "
    >
      <div>
        <el-table
          :data="tableData"
          style="width: 100%; background-color: #e6f0f2"
          :cell-style="cellStyle"
          :header-cell-style="headerStyle"
        
           height="400"
        >
          <el-table-column prop="unitName" label="单位名称" width="280">
          </el-table-column>
          <el-table-column
            prop="establishmentTime"
            label="成立时间"
            width="140"
          >
          </el-table-column>
          <el-table-column prop="address" label="注册地址" width="450">
          </el-table-column>
          <el-table-column prop="capital" label="注册资本（万元）" width="150">
          </el-table-column>
          <el-table-column prop="shareholder" label="股东名称">
          </el-table-column>
          <el-table-column prop="ratio" label="持股比例" width="100">
          </el-table-column>
        </el-table>
        <div
        style="width: 50%; margin: 0 auto; padding-top: 10px; min-width: 730px"
      >
        <p style="certen">如有疑问或发现假冒五所（赛宝）名称、商标的情况，请咨询 38390984，gaojing@ceprei.com </p>
        </div>
        
      </div>
    </div>
    <div
      style="widht: 20px; height: 1800px; background-color: #e6f0f2"
      v-show="seachShow"
    ></div>
    <br />&nbsp;<br />&nbsp;<br />&nbsp;<br />&nbsp;<br />&nbsp;<br />&nbsp;<br />&nbsp;
    <br />&nbsp;<br />&nbsp;<br />&nbsp;
    <div
      style="
        position: fixed;
        bottom: 0;
        z-index: 999;
        width: 100%;
        background-color: #3e4753;
        color: rgb(218, 213, 213);
        font-size: 14px;
      "
    >
      <div align="center" style="width: 100%; background-color: #e6f0f2">
        <a
          href="http://guangzhou.cyberpolice.cn/netalarm/netalarm/Welcome.jsp?bano=4401060100873"
          data-v-4d3159fe=""
          target="_blank"
        >
          <img
            src="https://ca.ceprei.com/_nuxt/img/cyberpolice.bfb5ba4.gif"
            border="0"
            data-v-4d3159fe=""
        /></a>
      </div>
      <div
        style="width: 50%; margin: 0 auto; padding-top: 10px; min-width: 730px"
      >
        <div style="float: right">
          <a href="https://www.ceprei.com/index.html"
            ><img
              src="https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
          /></a>
        </div>
        <p>
          Copyright © 2015. 中国赛宝实验室 All rights reserved. &nbsp;<i
            class="icon-home"
          ></i
          >&nbsp;广州市增城区朱村街朱村大道西78号 &nbsp;粤ICP备09030372号
        </p>
        <p>网站维护：020-87237193 业务联系：020-87236881</p>
        
      </div>
    </div>
  </div>
</template>
 <script>
import { RequestGet, url } from "../../api/api";

export default {
  data() {
    return {
      errResult: "",
      reportCodeSeach: "",
      checkCodeSeach: "",
      seachShow: true,
      unitName: "",
      data: {},
      tableData: [],
    };
  },
  created: function () {
    document.title = "中国赛宝官方网站-证书报告验证中心";
  },
  methods: {
    verify(data) {
      if (data.unitName == "") {
        return "请输入查询名称";
      }
      return null;
    },
    loadData() {
      var requestData = { unitName: this.unitName };
      //验证是否为空
      var msg = this.verify(requestData);
      if (msg != null) {
        this.$alert(msg, "填写错误", { lockScroll: false });
        return;
      }

      //发送请求
      RequestGet("/information/findByName", requestData)
        .then((response) => {
          this.tableData = response.data;
          this.seachShow = false;
          console.log(response);
        })
        .catch((error) => {});
    },
    cellStyle() {
      return "background-color: #e6f0f2;color:black;border:1px solid  ";
    },
    headerStyle() {
      return "background-color: #e6f0f2;color:black;border:1px solid ";
    },
  },
};
</script>

    <style type="text/css">
input {
  height: 50px;
}
table {
  /* margin-top: 40px; */
  margin-left: 5px;
  font-size: 16px;
}
table tr {
  height: 60px;
}
table tr td {
  fo: 40px;
}
a {
  text-decoration: none;
}

.tdclass {
  width: 25%;
  font-weight: bold;
  padding-left: 5%;
}
.tdclass2 {
  width: 75%;
  padding-right: 5%;
}

.cell{
  color: black;
}


</style>	


// WEBPACK FOOTER //
// enterprise.vue?7256a328